import {  Component, Vue } from "vue-property-decorator"
import { financeBackMoneyStatisticalData, financeBackMoneyStatisticalDataExport } from '@/api/financial-center'
import { delNullProperty } from '@/utils/index'
import { formatDate } from '@/utils/timeFilter'
import {UserModule} from "@/store/modules/user";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData";

@Component({
  components:{
    MoreUsersFilter
  }
})
export default class OrderStatisticsData extends Vue {

  page = 1
  limit = 20
  total = 0
  dissertationType = ''

  tableData = []
  tableLoading = false

  popover1 = false
  popover2 = false
  popover3 = false
  exportButtonDisabled = false
  exportHeaderDialogVisible = false
  tableHeader: any = [
    { filds: 'customerName', cnFilds: '客户名称', isShow: true, id: 1 },
    { filds: 'souCourseName', cnFilds: '项目名称', isShow: true, id: 2 },
    { filds: 'souCourseType', cnFilds: '项目种类', isShow: true, id: 3 },
    { filds: 'souCourseSchoolBegin', cnFilds: '开课时间', isShow: true, id: 4 },
    { filds: 'souCoursePrice', cnFilds: '项目终端售价', isShow: true, id: 5 },
    { filds: 'managementExpense', cnFilds: '项目管理费', isShow: true, id: 6 },
    { filds: 'marketCooperationName', cnFilds: '合作伙伴名称', isShow: true, id: 7 },
    { filds: 'marketCooperationTypes', cnFilds: '合作伙伴类型', isShow: true, id: 8 },
    { filds: 'marketCooperationSource', cnFilds: '合作伙伴来源', isShow: true, id: 9 },
    { filds: 'financeBackMoneyPrice', cnFilds: '回款金额', isShow: true, id: 10 },
    { filds: 'account', cnFilds: '收款账户', isShow: true, id: 11 },
    { filds: 'payAccount', cnFilds: '付款账户', isShow: true, id: 12 },
    { filds: 'backMoneyAt', cnFilds: '回款日期', isShow: true, id: 13 },
    { filds: 'createdAt', cnFilds: '回款创建时间', isShow: true, id: 14 },
    { filds: 'code', cnFilds: '回款编号', isShow: true, id: 15 },
    { filds: 'status', cnFilds: '回款状态', isShow: true, id: 16 },
    { filds: 'financeOrderCode', cnFilds: '订单编号', isShow: true, id: 17 },
    { filds: 'remark', cnFilds: '备注', isShow: true, id: 18 },
    { filds: 'commissionType', cnFilds: '佣金类型', isShow: true, id: 19 },
    { filds: 'ratio', cnFilds: '返点比例', isShow: true, id: 20 },
    { filds: 'financeOrderPrice', cnFilds: '订单金额', isShow: true, id: 21 },
    { filds: 'financeOrderDiscountPrice', cnFilds: '优惠金额', isShow: true, id: 22 },
    { filds: 'financeOrderRemark', cnFilds: '订单备注', isShow: true, id: 23 },
    { filds: 'financeRepeatOrderFlag', cnFilds: '撞单', isShow: true, id: 24 },
    { filds: 'financeMarketCostSum', cnFilds: '市场费用金额', isShow: true, id: 25 },
    { filds: 'marketClueDirectorUserRealName', cnFilds: '市场负责人', isShow: true, id: 26 },
    { filds: 'financeOrderCreatedUserRealName', cnFilds: '订单创建人', isShow: true, id: 27 },
    { filds: 'financeOrderCooperationUserRealName', cnFilds: '合作成单同事', isShow: true, id: 28 },
    { filds: 'financeOrderAchievementRatio', cnFilds: '业绩比例分配', isShow: true, id: 29 },
    { filds: 'customerDirectorUserRealName', cnFilds: '客户负责人', isShow: true, id: 30 },
    { filds: 'financeBackMoneyCreatedUserRealName', cnFilds: '回款创建人', isShow: true, id: 31 },
    { filds: 'marketChannelType', cnFilds: '渠道类型', isShow: true, id: 32 },
    { filds: 'marketClueCreatedUserRealName', cnFilds: '市场线索创建人', isShow: true, id: 33 },
  ]
  souCourseName = '' //	  项目名称
  souCourseType = '' //项目种类
  souCourseSchoolBegin = [] // 开课时间
  marketCooperationName = '' // 合作伙伴名称
  marketCooperationTypes = ''// 合作方类型
  createdAt = [] // 回款时间
  backMoneyAt = [] // 回款时间
  code = '' //回款编号
  financeOrderCode = '' // 订单编号
  financeOrderCreatedUserIdList = [] // 订单创建人
  customerDirectorUserIdList = [] // 客户负责人
  createdUserIdList = [] // 回款创建人
  souCourseTypeList = commonData.projectTypeArray
  marketCooperationTypeList = [
    {label: '个人代理', val: '0'},
    {label: '机构', val: '1'},
    {label: '学校', val: '2'},
  ]
  timer = null
  backMoneyAccount = '' //收款账户
  customerName = '' // 客户名称
  payAccount = ''

  created() {
    this.getTableData()
  }

  // 时间区间过滤器
  changeTime(val: Date[]): string {
    if (val == null) return ''
    let time = ''
    val.forEach((item: any) => {
      time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
    })
    time = time.slice(0, time.length - 1)
    return time
  }
  //backMoneyAt: this.changeTime(this.backMoneyAt as Date[]), //回款时间


  async getTableData() {
    this.popover1 = false
    this.popover2 = false
    this.popover3 = false
    this.tableLoading = true

    const { allNum, financeBackMoneyList } = await financeBackMoneyStatisticalData(delNullProperty({
      souCourseName : this.souCourseName,
      souCourseTypeId : this.souCourseType,
      souCourseSchoolBegin : this.changeTime(this.souCourseSchoolBegin),
      marketCooperationName : this.marketCooperationName,
      marketCooperationTypes : this.marketCooperationTypes,
      createdAt : this.changeTime(this.createdAt),
      backMoneyAt : this.changeTime(this.backMoneyAt),
      code : this.code,
      financeOrderCode : this.financeOrderCode,
      financeOrderCreatedUserIdList : this.financeOrderCreatedUserIdList,
      createdUserIdList : this.createdUserIdList,
      account : this.backMoneyAccount,
      customerName : this.customerName,
      payAccount : this.payAccount,
      limit: this.limit,
      page: this.page,
    })) as unknown as { allNum: number; financeBackMoneyList: any[] }
    this.tableData = financeBackMoneyList
    this.total = allNum
    this.tableLoading = false

  }

  async exportExcel(keys: string = '') {
    this.exportButtonDisabled = true
    await financeBackMoneyStatisticalDataExport(delNullProperty({
          souCourseName: this.souCourseName,
          souCourseTypeId: this.souCourseType,
          souCourseSchoolBegin: this.changeTime(this.souCourseSchoolBegin),
          marketCooperationName: this.marketCooperationName,
          marketCooperationTypes: this.marketCooperationTypes,
          createdAt: this.changeTime(this.createdAt),
          backMoneyAt: this.changeTime(this.backMoneyAt),
          code: this.code,
          financeOrderCode: this.financeOrderCode,
          financeOrderCreatedUserIdList: this.financeOrderCreatedUserIdList,
          createdUserIdList: this.createdUserIdList,
          customerName: this.customerName,
          account: this.backMoneyAccount,
          payAccount: this.payAccount,
          keys,
        })
    ).then(()=>{
      this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    }).finally(() => {
      this.exportButtonDisabled = false
    })
  }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }

  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }

  changeCreatedUserIdList(e) {
    this.createdUserIdList = e.id
    this.page = 1
    this.getTableData()
  }
  changeFinanceOrderCreatedUserIdList(e) {
    this.financeOrderCreatedUserIdList = e.id
    this.page = 1
    this.getTableData()
  }

}
